import styled from 'styled-components';
import { appConfig } from 'config/app';
import { theme, toRem } from 'design';

export const NeedHelpLink = styled.a.attrs({
  href: appConfig.LINKS.SUPPORT,
  rel: 'noopener noreferrer',
  target: '_blank',
})`
  margin: ${toRem(22)} 0 0;
  font-weight: ${theme.font.weight.semiBold};
  font-size: ${toRem(13.75)};
  text-decoration: underline;
  color: ${theme.color.primary[500]};
  cursor: pointer;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: ${theme.color.primary[500]};
  }
`;
